import { createSlice } from "@reduxjs/toolkit";
import { languageIsEnglish } from "web/script/modules/language";
import browser from "web/script/utils/browser";

interface AppHeaderBarSlice {
    isAssistedSearchOpen: boolean;
    isSearchOpen: boolean;
    isCalloutOpen: boolean;
    fetchWishlist: boolean;
    isWhishlistAnimating: boolean;
}

const appHeaderBar = createSlice({
    name: "appHeaderSearch",
    initialState: {
        isAssistedSearchOpen: false,
        isSearchOpen: false,
        isCalloutOpen: false,
        fetchWishlist: true,
        isWhishlistAnimating: false,
    } as AppHeaderBarSlice,
    reducers: {
        openAssistedSearch(state): void {
            if (languageIsEnglish() && browser.getViewport() === browser.VIEWPORTS.DESKTOP) {
                state.isAssistedSearchOpen = true;
            }
        },
        closeAssistedSearch(state): void {
            state.isAssistedSearchOpen = false;
        },
        openSearch(state): void {
            state.isSearchOpen = true;
        },
        closeSearch(state): void {
            state.isSearchOpen = false;
        },
        openCallout(state): void {
            state.isCalloutOpen = true;
        },
        closeCallout(state): void {
            state.isCalloutOpen = false;
        },
        startWhishlistAnimation(state): void {
            state.isWhishlistAnimating = true;
        },
        stopWhishlistAnimation(state): void {
            state.isWhishlistAnimating = false;
        },
        startFetchingWishlist(state): void {
            state.fetchWishlist = true;
        },
        stopFetchingWishlist(state): void {
            state.fetchWishlist = false;
        },
    },
});

// Extract the action creators object and the reducer
const { actions, reducer } = appHeaderBar;
// Extract and export each action creator by name
export const {
    openAssistedSearch,
    closeAssistedSearch,
    openSearch,
    closeSearch,
    openCallout,
    closeCallout,
    startWhishlistAnimation,
    stopWhishlistAnimation,
    startFetchingWishlist,
    stopFetchingWishlist,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
